"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iReportStatusEvent = exports.GENERATE_REPORT_FAILED = exports.GENERATE_REPORT_SUCCESS = void 0;
const t = require("io-ts");
exports.GENERATE_REPORT_SUCCESS = 'GENERATE_REPORT_SUCCESS';
exports.GENERATE_REPORT_FAILED = 'GENERATE_REPORT_FAILED';
const iMessage = t.intersection([
    t.interface({ reportUuid: t.string }),
    t.partial({ downloadLink: t.string })
]);
exports.iReportStatusEvent = t.interface({
    event: t.keyof({
        [exports.GENERATE_REPORT_SUCCESS]: null,
        [exports.GENERATE_REPORT_FAILED]: null
    }),
    message: iMessage
});
//# sourceMappingURL=reportEvent.js.map